export enum ProfileOptionAction {
  Message = 'message',
  Report = 'report'
}
